import { put } from "typed-redux-saga";
import { takeEveryFsa } from "../operations";
import { appActions } from "./actions";

const baseDir = window.location.href.substring(
  0,
  window.location.href.indexOf("/#/"),
);

export function* appSaga() {
  yield takeEveryFsa(appActions.showModal.started, function* (action) {
    yield* put(
      appActions.showModal.done({
        params: action.payload,
        result: {},
      }),
    );
  });

  yield takeEveryFsa(
    appActions.showMenuDetailPopup.started,
    function* (action) {
      yield* put(
        appActions.showMenuDetailPopup.done({
          params: action.payload,
          result: {},
        }),
      );
    },
  );

  yield takeEveryFsa(
    appActions.showStoreDetailPopup.started,
    function* (action) {
      yield* put(
        appActions.showStoreDetailPopup.done({
          params: action.payload,
          result: {},
        }),
      );
    },
  );
}
